import React, { useState } from 'react'
import { FbCheckbox, GridContainer, GridItem, } from '@fabricks/ui-components'
import MaterialTable from "../Materials/MaterialTable";
import { HR } from '../../components/Common/Common'
import { get as _get } from 'lodash'
import { FilterParam } from "../../api/models";

interface MaterialsPageProps {
    filter?: Filter
}

interface Filter {
    isInvalid: boolean | null
}

export const Materials: React.FC<MaterialsPageProps> = (props: MaterialsPageProps) => {
    const { filter: filterSettings } = props
    const [filter, setFilter] = useState<Filter>({
        isInvalid: _get(filterSettings, 'isInvalid', false),
    })

    const handleInvalidPackageTypeFilterChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setFilter({ ...filter, isInvalid: event.target.checked })
    }

    const createFilterParams = () => {
        const filterParams: FilterParam[] = []
        if (filter.isInvalid === true) {
            filterParams.push({ field: 'packageTypeUuid', exists: false })
        }
        return filterParams
    }
    return (
        <GridContainer>
            <GridItem xs={12} sm={12} md={12}>
                <FbCheckbox
                    id="invalidMaterialsFilter"
                    label="Invalid materials"
                    checked={filter.isInvalid || false}
                    onChange={handleInvalidPackageTypeFilterChange}
                />
                <HR />
                <MaterialTable filter={createFilterParams()} />
            </GridItem>
        </GridContainer>
    )
}
